import { Skeleton } from '@/components/ui/skeleton';
import { TableCell, TableRow } from '@/components/ui/table';

export default () => {
  return [...new Array(8)].map((_, index) => {
    return (
      <TableRow className="border-borderColor hover:!bg-[unset] h-[72px]" key={index}>
        {[...Array(3)].map((_, cIndex) => {
          return (
            <TableCell key={cIndex}>
              <Skeleton className="h-[42px] w-full rounded-xl" />
            </TableCell>
          );
        })}
      </TableRow>
    );
  });
};
